"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsActiveAlertTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _dmsbasereact = require("dmsbasereact");
var _AlertConstants = require("../../constants/AlertConstants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsActiveAlertTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("AlertMessage").d("Alert Message"),
    column_name: "alert_message",
    function: (value, row) => row && row.alert_message ? row.alert_message.title : '',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Provider").d("Provider"),
    column_name: "alert_provider",
    function: (value, row) => row && row.alert_provider ? row.alert_provider.name : '',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Snooze").d("Snooze"),
    column_name: "snooze",
    map: Object.fromEntries(Object.entries(_AlertConstants.SnoozeTypesEnum).map(_ref => {
      let [key, value] = _ref;
      return [value, key];
    })),
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("DateTimeBegin").d("Date Time Begin"),
    column_name: "date_time_begin",
    function: (value, row) => row && row.date_time_begin ? (0, _moment.default)(row.date_time_begin).format("DD/MM/YYYY HH:mm:ss") : '',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Group").d("Group"),
    column_name: "group_name",
    function: (value, row) => row && row.group_name ? row.group_name : '',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Recipients").d("Recipients"),
    column_name: "recipients",
    function: (value, row) => {
      if (!row || !row.recipients) return '';
      return row.recipients.map(r => r.user_name || r.user_email || r.user_pk).join(', ');
    },
    filter: false
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/alert_task/active",
    export_table: false,
    responsive: true
  });
};
exports.DmsActiveAlertTable = DmsActiveAlertTable;